import { Button, SplitColumnsContainer } from '@startlibs/components';
import {ConfirmDialog, validation,DatePicker, RadioboxGroup, SimpleRadiobox, TextInput} from '@startlibs/form'
import {navigate} from '@reach/router'
import {postFetcher, formatDate} from '@startlibs/utils'
import React from 'react'
import _ from 'lodash/fp'

import {setParams} from '../hooks/useUpdateParams'

const invalidChars = /[\\\/\*]/; // Regex to match \, /, or *

const preValidation = validation.buildValidation({
  // patientname:[validation.required, (v) => v?.length < 6 && "Patient name must be at least 6 characters long."],
  // patientid:[validation.required, (v) => v?.length < 6 && "Patient ID must be at least 6 characters long."],
  // patientsex:[validation.required],
  // patientdob:[validation.required],
  // studydesc:[validation.required],
  // studyinst:[validation.required],
  // studydate:[validation.required],
  // studyrefphys:[validation.required]
    patientname: [
      validation.required, 
      (v) => v?.length < 6 && "Patient name must be at least 6 characters long.", 
      (v) => invalidChars.test(v) && "Patient name cannot contain \\, /, or *"
    ],
    patientid: [
      validation.required, 
      (v) => v?.length < 6 && "Patient ID must be at least 6 characters long.", 
      (v) => invalidChars.test(v) && "Patient ID cannot contain \\, /, or *"
    ],
    patientsex: [
      validation.required
    ],
    patientdob: [
      validation.required
    ],
    studydesc: [
      validation.required, 
      (v) => invalidChars.test(v) && "Study description cannot contain \\, /, or *"
    ],
    studyinst: [
      validation.required, 
      (v) => invalidChars.test(v) && "Study institution cannot contain \\, /, or *"
    ],
    studydate: [
      validation.required
    ],
    studyrefphys: [
      validation.required, 
      (v) => invalidChars.test(v) && "Study referring physician cannot contain \\, /, or *"
    ]
});


const DATE_FORMAT = "yyyy-MM-dd"
const TRANSFORM_DATE_FORMAT = "yyyyMMdd"

const transform = _.flow(
  _.update('patientdob',(d) => formatDate(d,TRANSFORM_DATE_FORMAT)),
  _.update('studydate',(d) => formatDate(d,TRANSFORM_DATE_FORMAT))
)

const action = (values) => {
  const formData = new FormData()
  _.toPairs(values).map(([k,v]) => formData.append(k,v))
  return postFetcher("/jpeg2dicom/jpeg2dicom.php",formData)
}

export const CreateBlankStudyDialog = ({closeDialog}) => {
  const now = new Date();
  const timezoneOffsetMinutes = now.getTimezoneOffset();
  const timezoneOffsetHours = -timezoneOffsetMinutes / 60;
  const invalidCharsMessage = "Some fields contain invalid characters. The characters \\, /, and * are not allowed.";

  return <ConfirmDialog
    action={action}
    onSuccess={({patientid}) => {
      setParams({page:1,search:patientid})
    }}
    closeDialog={closeDialog}
    confirm={<Button highlight>Create</Button>}
    onFailure={(values, error, form) => {
      try{
        if(error[0]?.includes('Invalid Character')){
          form.setErrors({"Invalid Chars": invalidCharsMessage})
        }
      }catch(e){
        console.log(e)
      }
    }}
    cancelLabel="Cancel"
    title="Blank Study Creation"
    transform={transform}
    preValidation={preValidation}
  >
      <TextInput label="Patient Name" mandatory path="patientname"/>
      <TextInput label="Patient ID" mandatory path="patientid"/>
    
    <RadioboxGroup path="patientsex" label="Patient Sex" mandatory framedBoxes horizontal wide>
      <SimpleRadiobox label="Male"  fieldValue="M"/>
      <SimpleRadiobox label="Female" fieldValue="F"/>
    </RadioboxGroup>

    <DatePicker label="Patient Date of Birth" path="patientdob" mandatory format={DATE_FORMAT} timezoneOffset={timezoneOffsetHours} />

    <SplitColumnsContainer>
      <TextInput label="Study Description" path="studydesc" mandatory />
      <TextInput label="Study Institution" path="studyinst" mandatory />
    </SplitColumnsContainer>

    <SplitColumnsContainer>
      <DatePicker label="Study Date" path="studydate" mandatory format={DATE_FORMAT} timezoneOffset={timezoneOffsetHours} />
      <TextInput label="Referring Physician" path="studyrefphys" mandatory/>
    </SplitColumnsContainer>

  </ConfirmDialog> 
  }